module.exports = __webpack_public_path__ + "static/media/Pattern.f665635b.png";